import React, { memo } from 'react';

import { Form, Formik } from 'formik';

import Fields from './fields';

interface IProps {
  product?: number | string;
  onChange?: (product: number) => void;
  onConfirm?: (product: number) => void;
}

const Filters = ({ product, onChange, onConfirm }: IProps) => {
  const productId = product != null && product !== '' ? Number(product) : undefined;

  return (
    <div>
      <Formik
        initialValues={{ product_id: productId != null && !Number.isNaN(productId) ? productId : undefined }}
        onSubmit={() => {}}
      >
        {() => (
          <Form>
            <Fields onConfirm={onConfirm} onChange={onChange} />
          </Form>
        )}
      </Formik>
    </div>
  );
};

export default memo(Filters);
